import type { UserChartEntry } from '../services/api';

type Chart = { chart_type: string; setting?: Record<string, unknown> };
function stable(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(stable);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => [key, stable(item)]));
  return value;
}
/** The dashboard supplies one shared date range; titles and layout are not data variants. */
export function chartIdentity(chart: Chart): string {
  const s = chart.setting ?? {};
  const sports = Array.isArray(s.workout_types) && s.workout_types.length ? [...new Set(s.workout_types.map(String))].sort() : ['0'];
  const base = { sports: sports.includes('0') ? ['0'] : sports };
  let options: unknown;
  if (chart.chart_type === 'periodic_chart') {
    const summary = s.workout_summery as Record<string, unknown> | undefined;
    options = { ...base, metric: summary?.workout_summery_types ?? 'tss_actual', group: summary?.group_by ?? 'week' };
  } else if (chart.chart_type === 'time_in_zone') {
    options = { ...base, zone: s.zone_type ?? 'time_in_zone_hr' };
  } else if (chart.chart_type === 'fitness_summery_chart') {
    options = { ...base, metric: s.fitness_type ?? 'distance' };
  } else {
    const { chart_title, index, date_range, workout_types, ...rest } = s;
    options = { ...base, ...rest };
  }
  return JSON.stringify([chart.chart_type, stable(options)]);
}
export function uniqueCharts(charts: UserChartEntry[]): UserChartEntry[] {
  const seen = new Set<string>();
  return charts.filter(chart => { const key = chartIdentity(chart); if (seen.has(key)) return false; seen.add(key); return true; });
}
